import { NgModule } from '@angular/core';
import { PushPipe } from './push.pipe';

@NgModule({
  declarations: [PushPipe],
  exports: [PushPipe],
})
export class PushModule {}
